<div class="container-fluid p-0">
  <div class="authentication-main">
    <div class="row">
      <div class="col-md-12">
        <div class="auth-innerright">
          <div class="authentication-box">
            <div class="card mt-6">
              <div class="card-header bg-info">
                <div class="text-center"><img src="../../../assets/images/logo/logo-inniver-small.png" alt=""></div>
              </div>
              <div class="card-body bg-grey">
                <h4>Reset Your Password</h4>
                <form class="ngx-form" [formGroup]="forgotForm" novalidate>
                  <div class="form-group">
                    <div class="form-row">
                      <div class="col-md-12">
                        <label class="control-label" for="email">Email</label>
                        <input type="email" formControlName="email" class="form-control" autocomplete="off"
                          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" [email]="true" required="required" placeholder="enter Email.." (keyup)="onKey($event)">
                        <div
                          *ngIf="forgotForm.controls['email'].invalid && (forgotForm.controls['email'].dirty || forgotForm.controls['email'].touched)"
                          class="alert">
                          <div *ngIf="forgotForm.controls['email'].errors?.['pattern']">
                            Email is required and format should be <i>john@doe.com</i>
                          </div>
                          <div *ngIf="forgotForm.controls['email'].errors?.['required'] ">Email is required.</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-form-label">Enter your City</label>
                    <div class="form-row">
                      <div class="col-md-12">
                        <input type="text" formControlName="cityName" class="form-control" placeholder="enter city.." (keyup)="onKey($event)">
                        <div *ngIf="forgotForm.controls['cityName'].invalid && (forgotForm.controls['cityName'].dirty || forgotForm.controls['cityName'].touched)"
                          class="alert">
                          <div *ngIf="forgotForm.controls['cityName'].errors?.['required']">
                            City name created during registration is required.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>               

                  <div class="f1-buttons">
                    <button class="btn btn-pill btn-primary btn-submit" type="submit" [disabled]="!forgotForm.valid"
                    (click)="onSubmit()">Submit</button> 
                  </div>
                  <div class="form-group">
                    <div class="col-md-12" *ngIf="isLoginFailed">
                      <label class="control-label" for="f1-password">Oops...</label>
                      <div class="text-center alert alert-danger">something went wrong</div>
                    </div>
                  </div> 
                </form>
                </div>
          
            </div>   
            <div class="text-center">Send me back to the <a class="btn-link"
              href="authentication/login">login page</a></div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>